import { render, staticRenderFns } from "./GlobalFilter.vue?vue&type=template&id=1837d3eb&scoped=true&lang=html&"
import script from "./GlobalFilter.vue?vue&type=script&lang=js&"
export * from "./GlobalFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1837d3eb",
  null
  
)

export default component.exports